define('views/user/forgotpassword/resetpassword/securityquestions',["backbone",    
    "text!views/user/forgotpassword/resetpassword/securityquestions.html",
    "views/_base/baseview",
    "models/shared/lookups/systext",
    "views/user/forgotpassword/resetpassword/resetpassword",
    "models/shared/securityquestions/securityquestion",
    "models/shared/securityquestions/securityquestion_collection"
], function (Backbone, Template, BaseView, SystemText, ResetView, SecurityQuestion, SecurityQuestionCollection) {
    "use strict";
    return BaseView.extend({
        id: "resetSecurityQuestion",
        tagName: "section",
        isRender: true,
        needsAuth: false,
        activityIndicator: false,
        template: _.template(Template),
        events: {
            "click #validateResetAnswer": "submitAnswer"
        },
        initialize: function (options) {
            options = options || {};
            this.UserGUID = options.UserGUID;
            this.FPG = options.GUID;
            this.elementName = options.elementName;
            BaseView.prototype.initialize(this);
        },
        render: function () {
            this.$el.html(this.template({ data: this.model.toJSON() }));                      
            return this;
        },
        submitAnswer: function (e) {

            if (e && e.preventDefault) { e.preventDefault(); }
            if (e && e.stopPropagation) { e.stopPropagation(); }

            var securityQuestions = new SecurityQuestionCollection();
            var securityQuestion = new SecurityQuestion(null,{ parse: true });
            securityQuestion.set("EID", this.model.ExtSecurityQuestionID);
            securityQuestions.add(securityQuestion.set("A", encrypt(this.$("#resetAnswerSet1").val())));
            var that = this;            
            var url = pf.url + "/Machine/Validate?UserGUID=" + this.UserGUID + "&FingerPrint=" + $.fingerprint() + "&Remember=true";
            $.ajax({
                type: 'POST',
                async: false,
                data: JSON.stringify(securityQuestions),
                url: url,
                contentType: "application/json",
                success: function () {
                    that.resetView = new ResetView({ GUID: that.FPG, elementName: "#mainRegion" });
                },
                error: function () {                    
                    pfdialog.error({ context: this, Body: "Failed to verify the provided answer", Title: "Failed" });
                    
                }
            });
        },
        close: function () { }
    });
});
